import { render, staticRenderFns } from "./loyaltyBenefitsMoments.vue?vue&type=template&id=0238aa1e&"
import script from "./loyaltyBenefitsMoments.vue?vue&type=script&lang=js&"
export * from "./loyaltyBenefitsMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports